const createPromise = <T = void>(
  executor: (
    resolve: (value: T | PromiseLike<T>) => void,
    reject: (reason?: unknown) => void
  ) => void
): Promise<T> => {
  return new Promise(executor);
};

export default createPromise;
